import React, { useEffect, useState } from "react";
import { PhoneInput } from "react-international-phone";
import "react-international-phone/style.css";

interface InternationalPhoneInputProps {
  phoneData?: { phone?: string; code?: string };
  setPhoneData: React.Dispatch<
    React.SetStateAction<{
      phone?: string | undefined;
      code?: string | undefined;
    }>
  >;
  style?: React.CSSProperties;
  disabled?: boolean;
}

export const InternationalPhoneInput = ({
  phoneData,
  setPhoneData,
  style,
  disabled,
}: InternationalPhoneInputProps) => {
  const [phoneInput, setPhoneInput] = useState("");

  useEffect(() => {
    if (phoneData?.phone && phoneData?.code) {
      setPhoneInput(`+${phoneData?.code}+${phoneData?.phone}`);
    }
  }, [phoneData?.code, phoneData?.phone]);

  const onChange = (phone: string, code: string | undefined) => {
    setPhoneInput(phone);
    if (code && phone?.length) {
      const codeFormatted = `+${code}`;
      if (phone.startsWith(codeFormatted)) {
        const phoneFormatted = phone.slice(codeFormatted.length);
        setPhoneData({
          ...phoneData,
          phone: phoneFormatted,
          code: code,
        });
      }
    }
  };
  return (
    <PhoneInput
      defaultCountry={"br"}
      inputStyle={{ ...style }}
      forceDialCode
      value={phoneInput}
      onChange={(phone, meta) => onChange(phone, meta.country.dialCode)}
      disabled={disabled}
    />
  );
};
